import { create } from 'zustand';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://vclass.vskul.com/api';

export const useAuthStore = create((set, get) => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  isLoading: false,
  error: null,

  register: async (email, password, firstName, lastName, accountType = 'student') => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/auth/register`, {
        email,
        password,
        first_name: firstName,
        last_name: lastName,
        account_type: accountType,
      });
      const { user, access_token, refresh_token } = response.data;
      set({
        user,
        accessToken: access_token,
        refreshToken: refresh_token,
        isLoading: false,
      });
      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('refreshToken', refresh_token);
      return user;
    } catch (error) {
      const message = error.response?.data?.message || 'Registration failed';
      set({ error: message, isLoading: false });
      throw error;
    }
  },

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });
      const { user, access_token, refresh_token } = response.data;
      set({
        user,
        accessToken: access_token,
        refreshToken: refresh_token,
        isLoading: false,
      });
      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('refreshToken', refresh_token);
      return user;
    } catch (error) {
      const message = error.response?.data?.message || 'Login failed';
      set({ error: message, isLoading: false });
      throw error;
    }
  },

  logout: async () => {
    try {
      const { accessToken } = get();
      if (accessToken) {
        await axios.post(
          `${API_URL}/auth/logout`,
          {},
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      set({ user: null, accessToken: null, refreshToken: null, error: null });
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    }
  },

  getCurrentUser: async () => {
    const { accessToken } = get();
    if (!accessToken) return null;
    try {
      const response = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      set({ user: response.data.user });
      return response.data.user;
    } catch (error) {
      console.error('Get user error:', error);
      return null;
    }
  },

  refreshAccessToken: async () => {
    const { refreshToken } = get();
    if (!refreshToken) return false;
    try {
      const response = await axios.post(`${API_URL}/auth/refresh`, {
        refresh_token: refreshToken,
      });
      const { access_token } = response.data;
      set({ accessToken: access_token });
      localStorage.setItem('accessToken', access_token);
      return true;
    } catch (error) {
      console.error('Token refresh error:', error);
      set({ accessToken: null, refreshToken: null });
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      return false;
    }
  },

  restoreSession: () => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    if (accessToken && refreshToken) {
      set({ accessToken, refreshToken });
      return true;
    }
    return false;
  },

  setError: (error) => set({ error }),
}));
